import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

interface RequireAuthProps {
  children: ReactNode
  fallback?: ReactNode
  loadingFallback?: ReactNode
  redirectTo?: string
}

const DefaultLoading = () => (
  <div className="auth-guard-loading">
    <p>Checking your account...</p>
  </div>
)

export const RequireAuth = ({
  children,
  fallback,
  loadingFallback,
  redirectTo = '/login',
}: RequireAuthProps) => {
  const { ready, isAuthenticated } = useAuth()
  const location = useLocation()

  if (!ready) {
    return loadingFallback ?? <DefaultLoading />
  }

  if (!isAuthenticated) {
    if (fallback) {
      return fallback
    }
    return <Navigate to={redirectTo} replace state={{ from: `${location.pathname}${location.search}` }} />
  }

  return <>{children}</>
}

export default RequireAuth
